import { NSModal } from 'bricks';

export interface ISofrDisclaimerModalProps {
    isOpen: boolean;
    toggle: () => void;
    onAccept: () => void;
}

const SofrDisclaimerModal = ({ isOpen, toggle, onAccept }: ISofrDisclaimerModalProps) => (
    <NSModal
        isOpen={isOpen}
        toggle={toggle}
        modalHeaderText="Use SOFR forward projections?"
        modalHeaderClassName="text-white bg-primary"
        modalFooterButtonText="I accept"
        modalFooterButtonFunction={onAccept}
        modalFooterCancelButtonText="Cancel"
    >
        <div className="text-white">
            <p className="mb-2">
                CME-sourced 1-Month Term SOFR forward projections will auto-populate the next 24 months from the current period.
                Beyond month 24, the curve holds flat at the last projected rate, and you can override any period to reflect your own view.
            </p>
            <p className="mb-0">
                These are market estimates and may not match actual future rates — by clicking I accept, you acknowledge the 
                risk of relying on these projections for underwriting.
            </p>
        </div>
    </NSModal>
);

export default SofrDisclaimerModal;
